import { render } from "./specimenPageOMHM.vue?vue&type=template&id=9f11a112"
import script from "./specimenPageOMHM.vue?vue&type=script&lang=js"
export * from "./specimenPageOMHM.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__